/* Horizon Interiores — recálculo de preço na troca de variante + frete na PDP.
   Carregar uma única vez no theme.liquid:
   <script src="{{ 'hz-price.js' | asset_url }}" defer="defer"></script> */

(function () {
  var fmt = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  function money(cents) { return 'R$ ' + fmt.format(cents / 100); }
  function set(root, sel, text) { var el = root.querySelector(sel); if (el) el.textContent = text; }

  /* ---------- preço por variante ---------- */

  function renderPrice(variant) {
    if (!variant || variant.price == null) return;
    document.querySelectorAll('[data-hz-price]').forEach(function (root) {
      var disc = parseFloat(root.dataset.pixDiscount || '10');
      var n = parseInt(root.dataset.installments || '12', 10);
      var pix = Math.floor(variant.price * (100 - disc) / 100);

      root.dataset.variantId = variant.id;
      set(root, '[data-hz-pix]', money(pix));
      set(root, '[data-hz-savings]', money(variant.price - pix));
      set(root, '[data-hz-installment]', money(Math.ceil(variant.price / n)));
      set(root, '[data-hz-full]', money(variant.price));

      var anchor = root.querySelector('[data-hz-anchor]');
      if (anchor) {
        var on = variant.compare_at_price && variant.compare_at_price > variant.price;
        anchor.hidden = !on;
        if (on) {
          set(root, '[data-hz-compare]', 'De ' + money(variant.compare_at_price));
          set(root, '[data-hz-off]', '-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '% OFERTA');
        }
      }

      var ship = root.querySelector('[data-hz-ship]');
      if (ship) {
        ship.dataset.variantId = variant.id;
        var out = ship.querySelector('[data-hz-ship-result]');
        if (out) out.innerHTML = '';
      }
    });
    syncSticky();
  }

  /* Dawn / Horizon (Online Store 2.0) publicam a troca de variante pelo pub/sub
     interno, não por evento de DOM. Assinamos os dois caminhos. */
  function subscribeDawn() {
    if (typeof window.subscribe !== 'function' || !window.PUB_SUB_EVENTS) return false;
    window.subscribe(window.PUB_SUB_EVENTS.variantChange, function (event) {
      renderPrice(event && event.data && event.data.variant);
    });
    return true;
  }

  if (!subscribeDawn()) {
    // O bundle do tema pode carregar depois deste script.
    document.addEventListener('DOMContentLoaded', subscribeDawn);
    window.addEventListener('load', subscribeDawn);
  }

  // Temas que emitem evento de DOM próprio.
  ['variant:change', 'variantChange', 'product:variant-change'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      var d = e.detail || {};
      renderPrice(d.variant || (d.data && d.data.variant) || d);
    });
  });

  /* ---------- frete na página do produto ---------- */

  function zipDigits(value) { return (value || '').replace(/\D/g, ''); }

  /* HZ-FIX (estado obrigatório na cotação)
     A loja recusa /cart/shipping_rates.json sem `shipping_address[province]`:
     devolve HTTP 422 {"province":["Selecione um estado"]}. Sem isso TODA cotação caía
     no "Não encontramos frete para este CEP" — o cálculo de frete nunca funcionava.
     Como o cliente digita só o CEP, derivamos a UF das faixas oficiais dos Correios.
     Tabela local de propósito: nenhuma chamada a serviço externo, nenhuma dependência. */
  var UF_RANGES = [
    [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'], [30000, 39999, 'MG'],
    [40000, 48999, 'BA'], [49000, 49999, 'SE'], [50000, 56999, 'PE'], [57000, 57999, 'AL'],
    [58000, 58999, 'PB'], [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'], [69000, 69299, 'AM'],
    [69300, 69399, 'RR'], [69400, 69899, 'AM'], [69900, 69999, 'AC'], [70000, 72799, 'DF'],
    [72800, 72999, 'GO'], [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [78900, 78999, 'RO'], [79000, 79999, 'MS'],
    [80000, 87999, 'PR'], [88000, 89999, 'SC'], [90000, 99999, 'RS']
  ];

  function ufFromZip(zip) {
    var prefix = parseInt(zip.slice(0, 5), 10);
    if (isNaN(prefix)) return null;
    for (var i = 0; i < UF_RANGES.length; i++) {
      if (prefix >= UF_RANGES[i][0] && prefix <= UF_RANGES[i][1]) return UF_RANGES[i][2];
    }
    return null;
  }

  /* HZ-FIX (03/08/2026) — cotação assíncrona.
     Mesma correção aplicada no hz-cart.js. O GET /cart/shipping_rates.json é
     calculado na hora e sofre throttling da Shopify: quando a resposta não
     trazia `shipping_rates`, o código antigo mostrava "não encontramos frete",
     que o cliente lê como "não entregam aqui". Em aparelho que já tinha cotado
     o mesmo CEP a resposta vinha do cache e funcionava — por isso o problema
     aparecia em uns celulares e em outros não.
     Agora: POST prepare_shipping_rates → GET async_shipping_rates até ficar
     pronto. Lista vazia = sem cobertura de verdade; falha técnica tem mensagem
     própria. */
  var RATE_POLL_TRIES = 20;      // ~10s no total
  var RATE_POLL_DELAY = 500;     // ms entre tentativas

  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function rateQuery(zip, uf) {
    return 'shipping_address%5Bzip%5D=' + zip +
           '&shipping_address%5Bcountry%5D=Brazil' +
           '&shipping_address%5Bprovince%5D=' + uf;
  }

  /* HZ-FIX v3 (03/08/2026) — dois caminhos, e o erro se identifica.
     O caminho novo (prepare + async) é o preferido. Se ele falhar POR QUALQUER
     MOTIVO que não seja endereço inválido, caímos automaticamente no caminho
     antigo (GET com repetição) antes de mostrar erro ao cliente. E todo erro
     carrega um código curto (err.hz) que aparece na mensagem — ex.: "cód. T404"
     = poll do async parou com HTTP 404. Um print do cliente passa a bastar
     para diagnosticar. Códigos: Tnnn=async esgotou (nnn=último HTTP),
     Lnnn=caminho antigo esgotou, R=falha de rede/exceção, Annn=add.js falhou. */
  async function fetchRates(zip, uf, onWait) {
    var qs = rateQuery(zip, uf);
    try {
      return await asyncRates(qs, onWait);
    } catch (e) {
      if (e && e.code === 'ADDRESS') throw e;
      try {
        return await legacyRates(qs);
      } catch (e2) {
        if (e2 && !e2.hz) e2.hz = 'R';
        if (e2 && e && e.hz) e2.hz = e.hz + '/' + e2.hz;
        throw e2;
      }
    }
  }

  async function asyncRates(qs, onWait) {
    var jsonHeaders = { Accept: 'application/json' };
    var prep = await fetch('/cart/prepare_shipping_rates.json?' + qs, {
      method: 'POST', headers: jsonHeaders
    });

    if (prep.status === 422) { var addrErr = new Error('address'); addrErr.code = 'ADDRESS'; throw addrErr; }
    if (!prep.ok && prep.status !== 202) { var pe = new Error('prep'); pe.code = 'TIMEOUT'; pe.hz = 'P' + prep.status; throw pe; }

    var lastStatus = prep.status;
    for (var i = 0; i < RATE_POLL_TRIES; i++) {
      var res = await fetch('/cart/async_shipping_rates.json?' + qs, { headers: jsonHeaders });
      lastStatus = res.status;
      if (res.ok) {
        var data = null;
        try { data = await res.json(); } catch (e) { data = null; }
        // `null` = ainda calculando. Objeto com shipping_rates = resposta final.
        if (data && data.shipping_rates) return data.shipping_rates;
      }
      // Passados ~3s, avisa que ainda está calculando: silêncio longo parece travado.
      if (onWait && i === 5) { try { onWait(); } catch (e) {} }
      await sleep(RATE_POLL_DELAY);
    }
    var toErr = new Error('timeout'); toErr.code = 'TIMEOUT'; toErr.hz = 'T' + lastStatus; throw toErr;
  }

  async function legacyRates(qs) {
    var lastStatus = 0;
    for (var i = 0; i < 6; i++) {
      var res = await fetch('/cart/shipping_rates.json?' + qs, { headers: { Accept: 'application/json' } });
      lastStatus = res.status;
      if (res.status === 422) { var e = new Error('address'); e.code = 'ADDRESS'; throw e; }
      if (res.ok) {
        var data = null;
        try { data = await res.json(); } catch (err) { data = null; }
        if (data && data.shipping_rates) return data.shipping_rates;
      }
      // 429 = limitação da Shopify: espera mais antes de insistir.
      await sleep(res.status === 429 ? 1500 : 700);
    }
    var t = new Error('timeout'); t.code = 'TIMEOUT'; t.hz = 'L' + lastStatus; throw t;
  }

  function renderRates(out, rates) {
    if (!rates || !rates.length) {
      out.innerHTML = '<p class="hz-ship__error">Ainda não entregamos neste CEP. Fale com a gente pelo WhatsApp.</p>';
      return;
    }
    out.innerHTML = rates.map(function (r) {
      var price = r.price != null ? r.price : r.total_price;
      var cents = typeof price === 'string' ? Math.round(parseFloat(price) * 100) : price;
      // HZ-FIX: /cart/shipping_rates.json devolve delivery_days como ARRAY (ex.: [3,5]).
      // Array vazio é truthy em JS e imprimia " · dias úteis" sem número nenhum.
      // delivery_range vem como datas ISO, não como contagem de dias — não serve aqui.
      var days = null;
      if (Array.isArray(r.delivery_days)) {
        if (r.delivery_days.length) days = r.delivery_days.join(' a ');
      } else if (r.delivery_days != null && r.delivery_days !== '') {
        days = r.delivery_days;
      }
      var label = r.presentment_name || r.name;
      return '<div class="hz-ship__rate"><span>' + label +
        (days ? ' · ' + days + ' dias úteis' : '') + '</span><span>' +
        (cents === 0 ? 'Grátis' : money(cents)) + '</span></div>';
    }).join('');
  }

  async function quote(root) {
    var input = root.querySelector('[data-hz-zip]');
    var out = root.querySelector('[data-hz-ship-result]');
    var zip = zipDigits(input && input.value);
    if (zip.length !== 8) {
      out.innerHTML = '<p class="hz-ship__error">Informe um CEP com 8 dígitos.</p>';
      input.focus();
      return;
    }

    // HZ-FIX: valida o CEP pelas faixas dos Correios e obtém a UF exigida pela cotação.
    var uf = ufFromZip(zip);
    if (!uf) {
      out.innerHTML = '<p class="hz-ship__error">CEP não reconhecido. Confira os 8 dígitos.</p>';
      input.focus();
      return;
    }

    // HZ-FIX (03/08/2026): uma cotação por vez. Aqui é mais grave que no
    // carrinho — esta função ADICIONA e depois remove um item do carrinho do
    // cliente. Duas cotações ao mesmo tempo embaralhavam a quantidade restaurada.
    if (root.dataset.hzQuoting === '1') return;
    root.dataset.hzQuoting = '1';

    out.textContent = 'Calculando…';

    // 1) endpoint de app de frete, quando a loja tem um
    if (window.HZ_SHIPPING_ENDPOINT) {
      try {
        var res = await fetch(window.HZ_SHIPPING_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ zip: zip, variant_id: root.dataset.variantId, quantity: 1 })
        });
        var data = await res.json();
        renderRates(out, data.rates);
      } catch (err) {
        out.innerHTML = '<p class="hz-ship__error">Não conseguimos calcular agora. Toque em calcular de novo.</p>';
      } finally {
        root.dataset.hzQuoting = '0';
      }
      return;
    }

    // 2) Ajax Cart API: cota sobre um carrinho temporário e desfaz a alteração
    //
    // HZ-FIX (carrinho do cliente): a versão anterior deduzia a quantidade anterior
    // da resposta do /cart/add.js. O add.js devolve a quantidade ADICIONADA (1), não o
    // total da linha — então quantidade_anterior virava 0 e o change.js apagava a linha
    // inteira. Cliente com 2 unidades no carrinho perdia as 2 ao calcular o frete.
    // Agora lemos o estado real do carrinho ANTES de adicionar e restauramos no finally,
    // inclusive quando a cotação falha no meio do caminho.
    var id = root.dataset.variantId;
    var prevQty = 0;
    var touched = false;
    try {
      var before = await fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });
      (before.items || []).forEach(function (i) {
        if (String(i.id) === String(id)) prevQty = i.quantity;
      });

      var addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      touched = addRes.ok;
      // Se o add falhou E o carrinho estava vazio, não há o que cotar:
      // aborta com código próprio em vez de esperar 10s por nada.
      if (!addRes.ok && !(before.items || []).length) {
        var ae = new Error('add'); ae.code = 'TIMEOUT'; ae.hz = 'A' + addRes.status; throw ae;
      }

      renderRates(out, await fetchRates(zip, uf, function () {
        out.textContent = 'Ainda calculando… só um instante.';
      }));
    } catch (err) {
      out.innerHTML = err && err.code === 'ADDRESS'
        ? '<p class="hz-ship__error">Não conseguimos validar esse CEP. Confira os 8 dígitos.</p>'
        : '<p class="hz-ship__error">Não conseguimos calcular agora. Toque em calcular de novo. <span class="hz-ship__errcode">(cód. ' + ((err && err.hz) || 'R') + ')</span></p>';
    } finally {
      if (touched) {
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: String(id), quantity: prevQty })
          });
        } catch (e) { /* nada a fazer: não travar a página por causa da restauração */ }
      }
      root.dataset.hzQuoting = '0';
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-hz-zip-submit]');
    if (!btn) return;
    quote(btn.closest('[data-hz-ship]'));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-hz-zip]');
    if (!input) return;
    e.preventDefault();
    quote(input.closest('[data-hz-ship]'));
  });

  document.addEventListener('input', function (e) {
    var input = e.target.closest('[data-hz-zip]');
    if (!input) return;
    var d = zipDigits(input.value).slice(0, 8);
    input.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  });

  /* ---------- barra fixa de compra no mobile ---------- */

  function syncSticky() {
    var bar = document.querySelector('[data-hz-sticky-buy]');
    var price = document.querySelector('[data-hz-price] [data-hz-pix]');
    if (bar && price) set(bar, '[data-hz-sticky-price]', price.textContent);
  }

  var buyForm = document.querySelector('[data-hz-sticky-buy]');
  if (buyForm) {
    var anchorEl = document.querySelector('[data-hz-price]');
    if (anchorEl && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        buyForm.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '0px 0px -120px 0px' }).observe(anchorEl);
    }
    syncSticky();
  }
})();
